import React, { Component } from 'react';
import PropTypes from 'prop-types';
import FormCheckbox from 'components/Checkbox';

export default class VatSelector extends Component {
    constructor(props) {
        super(props);
        this.state = {
            componentId: Math.floor(Math.random() * 0xFFFF),
        };
    }

    componentDidMount() {
        const { excludeVAT, setVAT } = this.props;
        setVAT(excludeVAT);
    }

    onChange(e) {
        const { setVAT } = this.props;

        setVAT(!e.target.checked);
    }

    render() {
        const { excludeVAT, products, className} = this.props;

        if (!window.Checkout.settings.show_exclude_vat || Object.keys(products).length === 0) {
            return null;
        }

        return (
            <FormCheckbox
                id={'vatcontroller' + this.state.componentId}
                name="vatcontroller"
                label="vat_selector_label"
                checked={!excludeVAT}
                onChange={this.onChange.bind(this)}
                className={className}
            />
        );
    }
}

VatSelector.propTypes = {
    excludeVAT: PropTypes.bool,
    products: PropTypes.object,
    setVAT: PropTypes.func.isRequired,
    className: PropTypes.string,
};
